function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.62 1.049S17.186 0 13 0C8.814 0 3.38 1.049 3.38 1.049L0 5V17.001l3.38 3.951s5.434 1.049 9.62 1.049c4.186 0 9.62-1.049 9.62-1.049L26 17.001V11 5l-3.38-3.951zM10 15.601V6.399L18 11l-8 4.601z",
  fill: "#E84344"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 1a4 4 0 100 8 4 4 0 000-8zm0 12a4 4 0 100 8 4 4 0 000-8zM0 5a4 4 0 004 4c2.209 0 3-1.791 3-4s-.791-4-3-4a4 4 0 00-4 4zm4 8a4 4 0 100 8 4 4 0 000-8z",
  fill: "#E84344"
});

function SvgSocialYt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Youtube",
    width: 26,
    height: 22,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgSocialYt;